import { Action, Dispatch } from "redux";
import { ThunkAction } from "redux-thunk";

import { getOrgId, OrganizationId, UploadIconContentTypes } from "api";
import { Credentials } from "auth";
import { State } from "redux/state";

export type UploadOrgIcon = "UPLOAD_ORG_ICON";
export const UPLOAD_ORG_ICON: UploadOrgIcon = "UPLOAD_ORG_ICON";
export type UploadOrgIconSuccess = "UPLOAD_ORG_ICON_SUCCESS";
export const UPLOAD_ORG_ICON_SUCCESS: UploadOrgIconSuccess = "UPLOAD_ORG_ICON_SUCCESS";
export type UploadOrgIconFailure = "UPLOAD_ORG_ICON_FAILURE";
export const UPLOAD_ORG_ICON_FAILURE: UploadOrgIconFailure = "UPLOAD_ORG_ICON_FAILURE";
export type UploadOrgIconClear = "UPLOAD_ORG_ICON_CLEAR";
export const UPLOAD_ORG_ICON_CLEAR: UploadOrgIconClear = "UPLOAD_ORG_ICON_CLEAR";

export interface UploadOrgIconAction extends Action {
    payload: {
        credentials: Credentials;
        orgId: OrganizationId;
        blob: Blob;
        contentType: UploadIconContentTypes;
    };
    type: UploadOrgIcon;
}

export function uploadOrgIcon(
    orgId: OrganizationId,
    blob: Blob,
    contentType: UploadIconContentTypes
): ThunkAction<void, State, undefined, UploadOrgIconAction> {
    return (dispatch: Dispatch<UploadOrgIconAction>, getState) => {
        const credentials = getState().auth.credentials;

        dispatch(uploadOrgIconWithCredentials(credentials, orgId, blob, contentType));
    };
}

function uploadOrgIconWithCredentials(
    credentials: Credentials,
    orgId: OrganizationId,
    blob: Blob,
    contentType: UploadIconContentTypes
): UploadOrgIconAction {
    return {
        payload: {
            blob,
            contentType,
            credentials,
            orgId: getOrgId(orgId)
        },
        type: UPLOAD_ORG_ICON
    };
}

export interface UploadOrgIconSuccessAction extends Action {
    payload: {
        logoUrl: string;
    };
    type: UploadOrgIconSuccess;
}

export function uploadOrgIconSuccess(logoUrl: string): UploadOrgIconSuccessAction {
    return {
        payload: { logoUrl },
        type: UPLOAD_ORG_ICON_SUCCESS
    };
}

export interface UploadOrgIconFailureAction extends Action {
    payload: {
        error: Error;
    };
    type: UploadOrgIconFailure;
}

export function uploadOrgIconFailure(error: Error): UploadOrgIconFailureAction {
    return {
        payload: {
            error
        },
        type: UPLOAD_ORG_ICON_FAILURE
    };
}

export interface UploadOrgIconClearAction extends Action {
    type: UploadOrgIconClear;
}

export function uploadOrgIconClear(): UploadOrgIconClearAction {
    return {
        type: UPLOAD_ORG_ICON_CLEAR
    };
}
